// Type de contact

import { defineMessage } from "react-intl";

/** Propriétaire */
export const CONTACT_TYPE_VALUE_PROVIDER = "provider";
/** Voyageur */
export const CONTACT_TYPE_VALUE_TRAVELLER = "traveller";

export const CONTACT_TYPES = {
  [CONTACT_TYPE_VALUE_PROVIDER]: {
    id: CONTACT_TYPE_VALUE_PROVIDER,
    label: "propriétaire",
  },
  [CONTACT_TYPE_VALUE_TRAVELLER]: {
    id: CONTACT_TYPE_VALUE_TRAVELLER,
    label: "voyageur",
  },
};

export const CONTACT_TYPE_INTL_MESSAGES = {
  byValue: {
    [CONTACT_TYPE_VALUE_PROVIDER]: {
      label: defineMessage({
        defaultMessage: "propriétaire",
      }),
    },
    [CONTACT_TYPE_VALUE_TRAVELLER]: {
      label: defineMessage({
        defaultMessage: "voyageur",
      }),
    },
  },
};

export const CONTACT_TYPE_LIST = Object.values(CONTACT_TYPES);
